import { Howl } from "howler";
export const ringingSound = new Howl({
  src: "/sounds/ring.wav",
  loop: true,
});
